import {API_QUERY_FILTER_NAME, API_QUERY_FILTER_PARAMS} from 'plugins/modules/filter/constants';
import {FilterValuesJoinType, IFilter, TFilterValue} from 'plugins/modules/filter/types';

const {FROM, TO} = API_QUERY_FILTER_PARAMS;

export class FiltersToApi {
    constructor(filters: IFilter[]) {
        this.filters = filters;

        this.init();
    }

    private filters: IFilter[];
    query: string = '';

    private getRangeFiltersQuery = (code: string, values: TFilterValue[]) => {
        const [from, to] = values;
        const filterStringArray = [];

        if (from !== undefined) {
            filterStringArray.push(`${API_QUERY_FILTER_NAME}[${code}][${FROM}]=${from}`);
        }

        if (to !== undefined) {
            filterStringArray.push(`${API_QUERY_FILTER_NAME}[${code}][${TO}]=${to}`);
        }

        return filterStringArray;
    };

    private getFiltersQuery = (code: string, values: TFilterValue[], valuesJoinType: FilterValuesJoinType) => {
        if (valuesJoinType === FilterValuesJoinType.SINGLE_VALUE) {
            const value = values[0];
            return value !== undefined ? [`${API_QUERY_FILTER_NAME}[${code}][]=${value}`] : [];
        }

        return values.map((value) => `${API_QUERY_FILTER_NAME}[${code}][]=${value}`);
    };

    private init = () => {
        const queryFilterList: string[] = [];

        this.filters.forEach((filter) => {
            const {code, values, valuesJoinType} = filter;

            let filterStringArray: string[];

            if (valuesJoinType === FilterValuesJoinType.RANGE) {
                filterStringArray = this.getRangeFiltersQuery(code, values);
            } else {
                filterStringArray = this.getFiltersQuery(code, values, valuesJoinType);
            }

            queryFilterList.push(filterStringArray.join('&'));
        });

        this.query = queryFilterList.join('&');
    };
}
